import instagram from "../images/footer_instagram.png";
import facebook from "../images/footer_facebook.png";
import linkedIn from "../images/footer_linkedin.png";
import utube from "../images/footer_youtube.png";
import tiktok from "../images/footer_tiktok.png";
import donate from "../images/footer_donate.png";

const Footer = () => {
  return (
    <div className="">
      {/* ---------------------------------------------------------------------------------------------------------------
      ---------------------------------------Footer section--------------------------------------------------------
      ----------------------------------------------------------------------------------------------------------------- */}
      <div className="bg-[#b24029] xs:pb-0 md:pb-0  md:pt-0 mdx:pt-0">
        <div className="mx-auto max-w-[1240px]">
          <div className="flex xs:py-16 xs:mb-0 md:mb-[3.8rem] md:py-0 xs:flex-col-reverse md:flex-row xs:items-center md:items-end w-full bg-[#b24029] md:min-h-[230px] overflow-hidden">
            <div className="xs:block md:pl-0 md:block md:w-[450px] mds:w-[380px] xs:w-4/5   lgx:text-[1.8rem] mdx:text-[1.6rem] md800:text-[1.3rem]  md:text-[1rem] sm:text-[1.8rem] xs:text-[1.5rem]  font-medium text-center  align-bottom">
              <button className="mt-6 xs:mr-0   md:mr-6   md:ml-7 block px-8 pt-[0.7rem] pb-[0.7rem] text-white bg-[#ff794e] rounded-full">
                <a
                  href="https://donorbox.org/sister-circle"
                  rel="noreferrer"
                  target="_blank"
                  className=""
                >
                  <img
                    src={donate}
                    className="lgx:w-[25px] mdx:w-[22px] md800:w-[18px] md:w-[18px] sm:w-[25px] xs:w-[20px] inline mr-2 mb-1.5"
                    alt="donate"
                  />
                  Donate
                </a>
              </button>
              <button className="mt-6 xs:mr-0 xs:ml-0  md:mr-6 md:ml-7 block px-8 pt-[0.7rem] pb-[0.7rem]  text-[#b24029] bg-[#DCB1FA] rounded-full">
                <a
                  href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                  rel="noreferrer"
                  target="_blank"
                >
                  Get support now
                </a>
              </button>
            </div>

            <div className="md:w-[330px] xs:w-4/5    md:mr-[1.5rem]    font-sans antialiased text-[1rem] leading-[1.24rem] tracking-[-0.01em] text-[#ffe1d9]">
              <h1 className="pb-0">Get in Touch</h1>
              <p className="pb-0 b-0 underline decoration-1 mds:text-[1.4rem] mds:leading-[1.64rem] xss:text-[1.4rem] xss:leading-[1.64rem]">
                <a
                  href="mailto:hello@sistercircle.org.uk"
                  rel="noreferrer"
                  target="_blank"
                >
                  hello@sistercircle.org.uk
                </a>
              </p>
              <p className="pb-3 b-0 underline decoration-1 mds:text-[1.4rem] mds:leading-[1.64rem] xss:text-[1.4rem] xss:leading-[1.64rem]">
                {" "}
                <a href="tel:020 7377 8725">020 7377 8725</a>{" "}
              </p>

              <h1 className="pb-2 pt-5 align-bottom">Follow us</h1>
              <a
                href="https://www.instagram.com/sistercirclelondon/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={instagram}
                  className="float-left h-[22px] pr-4"
                  alt="instagram"
                />
              </a>
               <a
                href="http://facebook.com/sistercirclelondon"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={facebook}
                  className="float-left h-[22px] pr-4"
                  alt="facebook"
                />
              </a>
                <a
                href="https://www.linkedin.com/company/sistercircle/"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={linkedIn}
                  className="float-left h-[22px] pr-4"
                  alt="linkedin"
                />
              </a>
              <a
                href="https://www.youtube.com/@sistercirclelondon"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={utube}
                  className="float-left h-[22px] pr-4 "
                  alt="youtube"
                />
              </a>
               <a
                href="https://www.tiktok.com/@sister.circle_"
                rel="noreferrer"
                target="_blank"
              >
                <img
                  src={tiktok}
                  className="float-left h-[22px] "
                  alt="tiktok"
                />
              </a>
             
            </div>
            {/* --------------------------------------------------------------------------------------------------------- */}

            <div className="md:w-[350px] xs:w-4/5   md:mr-[1.5rem]   font-sans antialiased text-[1rem] leading-[1.24rem] tracking-[-0.01em] text-[#ffe1d9]">
              <h1 className="pb-1 decoration-1">Address</h1>
              <p className="pb-0 pt-0 mb-0 mt-0">
                Brady Community Centre
                <br />
                192 Hanbury Street
                <br />
                London E1 5HU
              </p>
              <button className="mt-8 xs:mr-0 xs:ml-0  md:mr-0 md:ml-0 block px-4 py-[0.4rem] md:mb-0 xs:mb-8 text-[1rem] font-medium text-   text-[#ffe1d9] border-[#ffe1d9] border-2  border-solid rounded-full">
                <a
                  href="https://maps.app.goo.gl/kQFs986zu6fFnXCbA"
                  rel="noreferrer"
                  target="_blank"
                >
                  Google Maps
                </a>
              </button>
            </div>
          </div>
          <div className=" bg-[#b24029] text-[#ffe1d9] text-[0.7rem] border-t-[1px] md:mt-7 xs:pb-32 md:pb-7 px-7 pt-7 ">
            <h1 className="inline-block  pr-1">© 2026 Sister Circle.</h1>

            <ol className="inline-block xs:pt-2 md:pt-0">
              <li className="inline-block px-1">
                Registered charity in England and Wales (1033764)
              </li>
              <li className="inline-block px-1">
                <a href="/cookies" className="underline">Cookie Policy</a>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
